/**
 * Human-readable labels for tool calls displayed in the chat activity log.
 * Keyed by tool name as sent by the backend WebSocket.
 */
export const TOOL_LABELS: Record<string, string> = {
  // Generic tools
  get_platform_users: 'Fetching users',
  check_health: 'Checking health',
  list_platforms: 'Listing platforms',
  list_job_types: 'Listing job types',
  list_jobs: 'Listing jobs',
  get_job_status: 'Getting job status',
  list_extractors: 'Listing extractors',
  list_loaders: 'Listing loaders',
  list_data_records: 'Listing data records',
  authenticate_platform: 'Authenticating',
  make_api_request: 'Calling API',
  list_job_groups: 'Listing job groups',
  list_field_mappings: 'Listing field mappings',
  // Zoom tools
  list_zoom_phone_users: 'Listing Zoom Phone users',
  get_zoom_phone_user: 'Getting Zoom Phone user',
  add_zoom_phone_user: 'Adding Zoom Phone user',
  remove_zoom_phone_user: 'Removing Zoom Phone user',
  update_zoom_phone_user: 'Updating Zoom Phone user',
  list_zoom_users: 'Listing Zoom users',
  get_zoom_user: 'Getting Zoom user',
  create_zoom_user: 'Creating Zoom user',
  delete_zoom_user: 'Deleting Zoom user',
  list_zoom_sites: 'Listing Zoom sites',
  create_zoom_site: 'Creating Zoom site',
  list_zoom_call_queues: 'Listing Zoom call queues',
  get_zoom_call_queue: 'Getting Zoom call queue',
  create_zoom_call_queue: 'Creating Zoom call queue',
  delete_zoom_call_queue: 'Deleting Zoom call queue',
  add_user_to_zoom_queue: 'Adding user to queue',
  remove_user_from_zoom_queue: 'Removing user from queue',
  list_zoom_auto_receptionists: 'Listing Zoom auto receptionists',
  list_zoom_phone_numbers: 'Listing Zoom phone numbers',
  assign_zoom_phone_number: 'Assigning phone number',
  list_zoom_shared_line_groups: 'Listing shared line groups',
  list_zoom_common_areas: 'Listing common areas',
  // RingCentral tools
  list_rc_extensions: 'Listing RC extensions',
  get_rc_extension: 'Getting RC extension',
  create_rc_extension: 'Creating RC extension',
  update_rc_extension: 'Updating RC extension',
  list_rc_call_queues: 'Listing RC call queues',
  get_rc_call_queue: 'Getting RC call queue',
  create_rc_call_queue: 'Creating RC call queue',
  delete_rc_call_queue: 'Deleting RC call queue',
  get_rc_call_queue_members: 'Getting queue members',
  list_rc_sites: 'Listing RC sites',
  list_rc_phone_numbers: 'Listing RC phone numbers',
  list_rc_ivr_menus: 'Listing RC IVR menus',
  get_rc_account_info: 'Getting RC account info',
  // OpenClaw tesseract extension tools
  tesseract_call_platform_api: 'Calling platform API',
  tesseract_search_endpoints: 'Searching endpoints',
  tesseract_get_platform_users: 'Fetching users',
  tesseract_get_migration_guide: 'Loading migration guide',
  tesseract_create_zoom_user: 'Creating Zoom user',
  tesseract_enable_zoom_phone: 'Enabling Zoom Phone',
  tesseract_create_zoom_site: 'Creating Zoom site',
  tesseract_create_zoom_call_queue: 'Creating Zoom call queue',
  tesseract_add_user_to_zoom_queue: 'Adding user to queue',
  tesseract_configure_zoom_ar_ivr: 'Configuring IVR',
  tesseract_query_etl: 'Querying ETL database',
  tesseract_check_health: 'Checking health',
};
